import React from 'react';
import { Trans } from 'react-i18next';
import { Link, Text } from '@nimbus-ds/components';

interface TextWithLinkProps {
  i18nKey: string;
  href: string;
  t: (key: string) => string;
}

function TextWithLink({ i18nKey, href, t }: TextWithLinkProps): JSX.Element {
  return (
    <Text>
      <Trans
        t={t}
        i18nKey={i18nKey}
        components={{
          href: (
            <Link
              as="a"
              href={href}
              target="_blank"
              appearance="primary"
              rel="noopener noreferrer"
            >
              {''}
            </Link>
          ),
        }}
      />
    </Text>
  );
}

export default TextWithLink;
